export function isDatadogNativeCrashDiagnosticsAvailable(): boolean {
  return false;
}

export function crashNativeForDatadog(_message?: string): void {
  throw new Error('Datadog native crash diagnostics module is not available on web');
}

export function crashJavascriptForDatadog(message: string): void {
  setTimeout(() => {
    throw new Error(message);
  }, 0);
}
